(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-aph-product]');
    if (!root) return;

    var productJson = document.querySelector('[data-aph-product-json]');
    var product = productJson ? JSON.parse(productJson.textContent) : null;
    var form = root.querySelector('[data-aph-product-form]');
    var variantSelect = root.querySelector('[data-aph-variant-select]');
    var atc = root.querySelector('[data-aph-atc]');
    var priceEl = root.querySelector('[data-aph-product-price]');
    var compareEl = root.querySelector('[data-aph-product-compare]');
    var saveEl = root.querySelector('[data-aph-product-save]');
    var saleBadge = root.querySelector('[data-aph-sale-badge]');
    var lowStockEl = root.querySelector('[data-aph-low-stock]');
    var buyNow = root.querySelector('[data-aph-buy-now]');
    var conversion = root.querySelector('[data-aph-product-conversion]');
    var sticky = root.querySelector('[data-aph-product-sticky]');
    var stickyPrice = root.querySelector('[data-aph-sticky-price]');
    var stickyCompare = root.querySelector('[data-aph-sticky-compare]');
    var stickySave = root.querySelector('[data-aph-sticky-save]');
    var stickyAtc = root.querySelector('[data-aph-sticky-atc]');
    var stickyImage = root.querySelector('[data-aph-sticky-image]');
    var galleryPrev = root.querySelector('[data-aph-gallery-prev]');
    var galleryNext = root.querySelector('[data-aph-gallery-next]');
    var galleryTrack = root.querySelector('[data-aph-gallery-track]');
    var galleryDotsWrap = root.querySelector('[data-aph-gallery-dots]');
    var galleryThumbsWrap = root.querySelector('[data-aph-gallery-thumbs]');
    var galleryUi = root.querySelector('.aph-product__gallery-ui');
    var titleEl = root.querySelector('[data-aph-product-title]');
    var breadcrumbTitle = root.querySelector('[data-aph-breadcrumb-title]');
    var colorLabelEl = root.querySelector('[data-aph-color-label]');
    var colorPicker = root.querySelector('[data-aph-color-picker]');
    var lowStockThreshold = parseInt(root.dataset.lowStockThreshold || '5', 10);

    var slides = root.querySelectorAll('[data-aph-gallery-slide]');
    var dots = root.querySelectorAll('[data-aph-gallery-dot]');
    var thumbs = root.querySelectorAll('[data-aph-gallery-thumb]');
    var galleryCount = root.querySelector('[data-aph-gallery-count]');
    var currentSlide = 0;
    var mobileGalleryMq = window.matchMedia('(max-width: 989px)');
    var colorSwitchToken = 0;

    function isMobileGallery() {
      return mobileGalleryMq.matches;
    }

    function updateGalleryUi(index) {
      if (galleryCount && slides.length) {
        galleryCount.textContent = (index + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      if (!isMobileGallery()) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-thumb-focus', i === index);
        });
        var target = slides[index];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    function showSlide(index) {
      if (!slides.length) return;
      currentSlide = ((index % slides.length) + slides.length) % slides.length;
      if (isMobileGallery()) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === currentSlide);
          slide.setAttribute('aria-hidden', i === currentSlide ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === currentSlide);
        });
      }
      updateGalleryUi(currentSlide);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.getAttribute('data-aph-gallery-dot'), 10));
      });
    });

    function bindThumbListeners() {
      thumbs = root.querySelectorAll('[data-aph-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showSlide(parseInt(thumb.getAttribute('data-aph-gallery-thumb'), 10));
        });
      });
    }

    bindThumbListeners();

    if (galleryPrev) {
      galleryPrev.addEventListener('click', function () {
        showSlide(currentSlide - 1);
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', function () {
        showSlide(currentSlide + 1);
      });
    }

    var gallery = root.querySelector('[data-aph-product-gallery]');
    if (gallery && slides.length > 1) {
      var startX = 0;
      gallery.addEventListener('touchstart', function (e) {
        if (!isMobileGallery()) return;
        startX = e.changedTouches[0].screenX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (!isMobileGallery()) return;
        var diff = e.changedTouches[0].screenX - startX;
        if (Math.abs(diff) < 40) return;
        showSlide(diff < 0 ? currentSlide + 1 : currentSlide - 1);
      }, { passive: true });
    }

    mobileGalleryMq.addEventListener('change', function () {
      showSlide(currentSlide);
    });

    function formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'el-GR', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    }

    function updateLowStock(variant) {
      if (!lowStockEl || !variant) return;
      var qty = variant.inventory_quantity;
      var tracked = variant.inventory_management === 'shopify';
      if (tracked && qty > 0 && qty <= lowStockThreshold) {
        lowStockEl.textContent = 'Μόνο ' + qty + ' σε απόθεμα';
        lowStockEl.hidden = false;
      } else {
        lowStockEl.hidden = true;
      }
    }

    var activeColorFilter = null;

    function getProductMedia() {
      if (!product) return [];
      if (product.media && product.media.length) {
        return product.media
          .filter(function (m) {
            return !m.media_type || m.media_type === 'image';
          })
          .map(function (m) {
            return {
              id: m.id,
              alt: m.alt || '',
              src: m.src || (m.preview_image && m.preview_image.src) || '',
            };
          })
          .filter(function (m) {
            return !!m.src;
          });
      }
      if (product.images && product.images.length && typeof product.images[0] === 'object') {
        return product.images;
      }
      return (product.images || []).map(function (src) {
        return { src: src, alt: '', id: null };
      });
    }

    function getVariantColor(variant) {
      if (!variant) return null;
      if (product && product.options && product.options.length) {
        var idx = -1;
        for (var i = 0; i < product.options.length; i++) {
          var name = product.options[i];
          if (name === 'Χρώμα' || name === 'Color' || name === 'Colour') {
            idx = i;
            break;
          }
        }
        if (idx >= 0 && variant.options && variant.options[idx]) {
          return variant.options[idx];
        }
      }
      return variant.option1 || null;
    }

    function hasColorGroupedImages() {
      var media = getProductMedia();
      if (!media.length || !product || !product.variants) return false;
      var colorValues = {};
      product.variants.forEach(function (v) {
        var c = getVariantColor(v);
        if (c) colorValues[c] = true;
      });
      if (Object.keys(colorValues).length < 2) return false;
      var matched = 0;
      media.forEach(function (img) {
        if (img.alt && colorValues[img.alt]) matched += 1;
      });
      return matched >= 2;
    }

    function imagesForColor(color) {
      var media = getProductMedia();
      if (!media.length) return [];
      if (!color) {
        return media.map(function (img) {
          return img.src;
        });
      }
      var matched = media.filter(function (img) {
        return (img.alt || '') === color;
      });
      if (!matched.length) {
        return media.map(function (img) {
          return img.src;
        });
      }
      return matched.map(function (img) {
        return img.src;
      });
    }

    function syncGalleryForVariant(variant) {
      if (!variant) return;
      if (!hasColorGroupedImages()) {
        updateVariantImage(variant);
        return;
      }
      var color = getVariantColor(variant);
      if (color === activeColorFilter) {
        updateVariantImage(variant);
        return;
      }
      activeColorFilter = color;
      rebuildGallery(imagesForColor(color), color || (product && product.title) || '');
      showSlide(0);
      updateVariantImage(variant);
    }

    function updateVariantImage(variant) {
      if (!variant || !stickyImage) return;
      var imageId = variant.featured_image && variant.featured_image.id;
      var imageSrc = variant.featured_image && variant.featured_image.src;
      if (!imageSrc && variant.featured_media) {
        imageSrc =
          variant.featured_media.src ||
          (variant.featured_media.preview_image && variant.featured_media.preview_image.src);
        imageId = variant.featured_media.id;
      }
      if (imageSrc) {
        stickyImage.src = imageSrc.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_120x$1$2');
        return;
      }
      var media = getProductMedia();
      if (!imageId || !media.length) return;
      var image = media.find(function (img) {
        return img.id === imageId;
      });
      if (image && image.src) {
        stickyImage.src = image.src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_120x$1$2');
      }
    }

    function refreshGalleryRefs() {
      slides = root.querySelectorAll('[data-aph-gallery-slide]');
      dots = root.querySelectorAll('[data-aph-gallery-dot]');
      galleryCount = root.querySelector('[data-aph-gallery-count]');
    }

    function bindDotListeners() {
      dots = root.querySelectorAll('[data-aph-gallery-dot]');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showSlide(parseInt(dot.getAttribute('data-aph-gallery-dot'), 10));
        });
      });
    }

    function rebuildGallery(images, altText) {
      if (!galleryTrack) return;
      var list = images && images.length ? images : [];
      galleryTrack.innerHTML = list
        .map(function (src, index) {
          var loading = index === 0 ? 'eager' : 'lazy';
          var active = index === 0 ? ' is-active' : '';
          var hidden = index === 0 ? 'false' : 'true';
          return (
            '<figure class="aph-product__slide' +
            active +
            '" data-aph-gallery-slide aria-hidden="' +
            hidden +
            '">' +
            '<img class="aph-product__image" src="' +
            src +
            '" alt="' +
            (altText || '') +
            '" loading="' +
            loading +
            '">' +
            '</figure>'
          );
        })
        .join('');

      if (galleryDotsWrap) {
        if (list.length > 1) {
          galleryDotsWrap.innerHTML = list
            .map(function (_, index) {
              var active = index === 0 ? ' is-active' : '';
              return (
                '<button type="button" class="aph-product__dot' +
                active +
                '" data-aph-gallery-dot="' +
                index +
                '" aria-label="Εικόνα ' +
                (index + 1) +
                ' από ' +
                list.length +
                '"></button>'
              );
            })
            .join('');
          if (galleryUi) galleryUi.hidden = false;
        } else {
          galleryDotsWrap.innerHTML = '';
          if (galleryUi) galleryUi.hidden = true;
        }
      }

      if (galleryThumbsWrap) {
        if (list.length > 1) {
          galleryThumbsWrap.hidden = false;
          galleryThumbsWrap.innerHTML = list
            .map(function (src, index) {
              var active = index === 0 ? ' is-active' : '';
              return (
                '<button type="button" class="aph-product__thumb' +
                active +
                '" data-aph-gallery-thumb="' +
                index +
                '" aria-label="Εικόνα ' +
                (index + 1) +
                '">' +
                '<img class="aph-product__thumb-image" src="' +
                src +
                '" alt="' +
                (altText || '') +
                '" loading="lazy">' +
                '</button>'
              );
            })
            .join('');
        } else {
          galleryThumbsWrap.innerHTML = '';
          galleryThumbsWrap.hidden = true;
        }
      }

      if (galleryPrev) galleryPrev.hidden = list.length <= 1;
      if (galleryNext) galleryNext.hidden = list.length <= 1;

      refreshGalleryRefs();
      bindDotListeners();
      bindThumbListeners();
      currentSlide = 0;
      showSlide(0);

      if (stickyImage && list[0]) {
        stickyImage.src = list[0].replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_120x$1$2');
      }
    }

    function setActiveColorSwatch(handle) {
      if (!colorPicker) return;
      colorPicker.querySelectorAll('[data-aph-color-swatch]').forEach(function (btn) {
        var active = btn.getAttribute('data-aph-color-swatch') === handle;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    var variantColorPicker = root.querySelector('[data-aph-variant-color-picker]');

    function setActiveVariantColorSwatch(color) {
      if (!variantColorPicker || !color) return;
      variantColorPicker.querySelectorAll('[data-aph-variant-color]').forEach(function (btn) {
        var active = btn.getAttribute('data-aph-variant-color') === color;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (colorLabelEl) colorLabelEl.textContent = color;
    }

    function selectVariantColor(color) {
      if (!color || !form) return;
      var colorInput = null;
      form.querySelectorAll('[data-aph-option-input]').forEach(function (input) {
        var isColorInput =
          input.hasAttribute('data-aph-color-option-input') ||
          /χρώμα|χρωμα|color|colour/i.test(input.name || '');
        if (isColorInput && input.value === color) {
          colorInput = input;
        }
      });
      if (!colorInput) return;
      if (!colorInput.checked) {
        colorInput.checked = true;
      }
      setActiveVariantColorSwatch(color);
      colorInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (variantColorPicker) {
      variantColorPicker.addEventListener('click', function (event) {
        var swatch = event.target.closest('[data-aph-variant-color]');
        if (!swatch) return;
        event.preventDefault();
        selectVariantColor(swatch.getAttribute('data-aph-variant-color'));
      });
    }

    function applyColorProduct(nextProduct, colorLabel, pushState) {
      product = nextProduct;
      if (productJson) {
        productJson.textContent = JSON.stringify(nextProduct);
      }

      if (titleEl) titleEl.textContent = nextProduct.title;
      if (breadcrumbTitle) breadcrumbTitle.textContent = nextProduct.title;
      if (colorLabelEl && colorLabel) colorLabelEl.textContent = colorLabel;
      document.title = nextProduct.title;

      rebuildGallery(nextProduct.images, nextProduct.title);

      if (variantSelect) {
        variantSelect.innerHTML = nextProduct.variants
          .map(function (variant) {
            var selected = variant.id === nextProduct.variants[0].id ? ' selected' : '';
            var disabled = variant.available ? '' : ' disabled';
            return (
              '<option value="' +
              variant.id +
              '"' +
              selected +
              disabled +
              '>' +
              variant.title +
              '</option>'
            );
          })
          .join('');
      }

      updateVariant(nextProduct.variants[0]);
      setActiveColorSwatch(nextProduct.handle);

      if (pushState && nextProduct.url) {
        window.history.replaceState({ aphColorHandle: nextProduct.handle }, '', nextProduct.url);
      }
    }

    function switchProductColor(handle, colorLabel) {
      if (!handle || (product && product.handle === handle)) return;
      var token = ++colorSwitchToken;
      var swatch = colorPicker && colorPicker.querySelector('[data-aph-color-swatch="' + handle + '"]');
      if (swatch) swatch.classList.add('is-loading');

      fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product fetch failed');
          return response.json();
        })
        .then(function (nextProduct) {
          if (token !== colorSwitchToken) return;
          applyColorProduct(nextProduct, colorLabel, true);
        })
        .catch(function () {})
        .finally(function () {
          if (swatch) swatch.classList.remove('is-loading');
        });
    }

    if (colorPicker) {
      colorPicker.addEventListener('click', function (event) {
        var swatch = event.target.closest('[data-aph-color-swatch]');
        if (!swatch || swatch.classList.contains('is-active')) return;
        switchProductColor(
          swatch.getAttribute('data-aph-color-swatch'),
          swatch.getAttribute('data-aph-color-label') || ''
        );
      });
    }

    function updateDiscountUi(variant) {
      if (!variant) return;
      var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (hasDiscount) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (hasDiscount) {
          var diff = variant.compare_at_price - variant.price;
          saveEl.textContent = 'Εξοικονόμησε ' + formatMoney(diff);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (saleBadge) {
        if (hasDiscount) {
          var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          saleBadge.textContent = '−' + pct + '%';
          saleBadge.hidden = false;
        } else {
          saleBadge.hidden = true;
        }
      }
      if (stickyCompare) {
        if (hasDiscount) {
          stickyCompare.textContent = formatMoney(variant.compare_at_price);
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }
      if (stickySave) {
        if (hasDiscount) {
          var savePct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          stickySave.textContent = '−' + savePct + '%';
          stickySave.hidden = false;
        } else {
          stickySave.hidden = true;
        }
      }
    }

    function updateVariant(variant) {
      if (!variant) return;
      if (variantSelect) variantSelect.value = String(variant.id);
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      updateDiscountUi(variant);
      updateLowStock(variant);
      syncGalleryForVariant(variant);
      setActiveVariantColorSwatch(getVariantColor(variant));
      setQty(qtyInput ? qtyInput.value : 1);
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? atc.dataset.label || atc.textContent : 'Εξαντλήθηκε';
      }
      if (stickyAtc) stickyAtc.disabled = !variant.available;
    }

    if (atc && !atc.dataset.label) {
      atc.dataset.label = atc.textContent.trim();
    }

    var qtyInput = root.querySelector('[data-aph-qty-input]');
    var qtyMinus = root.querySelector('[data-aph-qty-minus]');
    var qtyPlus = root.querySelector('[data-aph-qty-plus]');

    function getQtyMax() {
      if (!product || !variantSelect) return null;
      var variant = product.variants.find(function (v) {
        return String(v.id) === variantSelect.value;
      });
      if (!variant || variant.inventory_management !== 'shopify' || variant.inventory_policy === 'continue') {
        return null;
      }
      return variant.inventory_quantity > 0 ? variant.inventory_quantity : 1;
    }

    function clampQty(value) {
      var qty = parseInt(value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      var max = getQtyMax();
      if (max !== null && qty > max) qty = max;
      return qty;
    }

    function setQty(value) {
      if (!qtyInput) return;
      qtyInput.value = String(clampQty(value));
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + 1);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQty(qtyInput.value);
      });
    }

    if (product && form) {
      var optionInputs = form.querySelectorAll('[data-aph-option-input]');
      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var selectedByName = {};
          form.querySelectorAll('[data-aph-option-input]:checked').forEach(function (checked) {
            selectedByName[checked.name] = checked.value;
          });
          var selectedOptions = (product.options || []).map(function (optName) {
            var key = 'options[' + optName + ']';
            return selectedByName[key];
          });
          var variant = product.variants.find(function (v) {
            if (!v.options || v.options.length !== selectedOptions.length) return false;
            return v.options.every(function (opt, idx) {
              return opt === selectedOptions[idx];
            });
          });
          if (!variant) return;
          updateVariant(variant);
          form.querySelectorAll('.aph-product__option-pill').forEach(function (pill) {
            var pillInput = pill.querySelector('input');
            pill.classList.toggle('is-selected', !!(pillInput && pillInput.checked));
          });
        });
      });

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var variant = product.variants.find(function (v) {
            return String(v.id) === variantSelect.value;
          });
          updateVariant(variant);
        });
      }
    }

    function trackInitiateCheckout(variant) {
      if (!variant) return;
      var payload = {
        content_name: product.title,
        content_ids: [String(variant.id)],
        content_type: 'product',
        value: (variant.price || 0) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        num_items: 1,
      };
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'InitiateCheckout', payload);
      }
      if (typeof window.ttq === 'object' && typeof window.ttq.track === 'function') {
        window.ttq.track('InitiateCheckout', {
          content_id: String(variant.id),
          content_name: product.title,
          content_type: 'product',
          value: payload.value,
          currency: payload.currency,
        });
      }
    }

    function ajaxAddAndOpenCart(trigger) {
      if (!form || !variantSelect) return;
      var variant = product && product.variants.find(function (v) {
        return String(v.id) === variantSelect.value;
      });
      if (!variant || !variant.available) return;

      if (trigger) trigger.classList.add('is-loading');

      var qtyInput = root.querySelector('[data-aph-qty-input]');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: quantity }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(
            new CustomEvent('aph:cart:added', {
              detail: { id: variant.id, quantity: quantity },
            })
          );
          document.dispatchEvent(new CustomEvent('aph:cart:open'));
        })
        .catch(function () {})
        .finally(function () {
          if (trigger) trigger.classList.remove('is-loading');
        });
    }

    function addToCart(trigger) {
      if (!form) return;
      ajaxAddAndOpenCart(trigger);
    }

    function goToCheckout(trigger) {
      if (!form) return;
      if (trigger) trigger.classList.add('is-loading');
      if (product && variantSelect) {
        var variant = product.variants.find(function (v) {
          return String(v.id) === variantSelect.value;
        });
        trackInitiateCheckout(variant);
      }
      var checkoutInput = form.querySelector('input[name="return_to"]');
      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'return_to';
        form.appendChild(checkoutInput);
      }
      checkoutInput.value = '/checkout';
      form.querySelector('[name="add"]')?.click();
    }

    if (buyNow) {
      buyNow.addEventListener('click', function () {
        goToCheckout(buyNow);
      });
    }

    document.addEventListener('aph:cart:added', function (e) {
      if (!product || !e.detail || !e.detail.id) return;
      var variant = product.variants.find(function (v) {
        return String(v.id) === String(e.detail.id);
      });
      trackAddToCart(variant);
    });

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        ajaxAddAndOpenCart(stickyAtc);
      });
    }

    if (sticky && conversion) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          var visible = entries[0] && entries[0].isIntersecting;
          sticky.hidden = visible || !isMobileGallery();
        },
        { threshold: 0, rootMargin: '0px 0px -40px 0px' }
      );
      stickyObserver.observe(conversion);
      mobileGalleryMq.addEventListener('change', function () {
        if (!isMobileGallery()) sticky.hidden = true;
      });
    }

    function trackViewContent() {
      if (!product) return;
      var variant = product.variants.find(function (v) {
        return String(v.id) === (variantSelect && variantSelect.value);
      }) || product.variants[0];
      var payload = {
        content_name: product.title,
        content_ids: [String(variant.id)],
        content_type: 'product',
        value: (variant.price || 0) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      };
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent', payload);
      }
      if (typeof window.ttq === 'object' && typeof window.ttq.track === 'function') {
        window.ttq.track('ViewContent', {
          content_id: String(variant.id),
          content_name: product.title,
          content_type: 'product',
          value: payload.value,
          currency: payload.currency,
        });
      }
    }

    function trackAddToCart(variant) {
      if (!variant) return;
      var payload = {
        content_name: product.title,
        content_ids: [String(variant.id)],
        content_type: 'product',
        value: (variant.price || 0) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      };
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', payload);
      }
      if (typeof window.ttq === 'object' && typeof window.ttq.track === 'function') {
        window.ttq.track('AddToCart', {
          content_id: String(variant.id),
          content_name: product.title,
          content_type: 'product',
          value: payload.value,
          currency: payload.currency,
        });
      }
    }

    trackViewContent();
    if (product && product.variants && product.variants.length) {
      var initialVariant =
        product.variants.find(function (v) {
          return variantSelect && String(v.id) === variantSelect.value;
        }) || product.variants[0];
      syncGalleryForVariant(initialVariant);
    } else {
      showSlide(0);
    }
  });
})();
